import request from '@/utils/request'

export function refreshToken() {
  return request({
    url: '/auth/refresh',
    method: 'post',
  })
}
